import { QuotationTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1602. 見積タスクコメント編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
  content: string;
  content_json: string;
};

const updateQuotationTaskComment = (props: Props): Promise<QuotationTaskComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_comments/${props.id}`,
    props
  );
};

export const useUpdateQuotationTaskComment = () => {
  return useMutation({
    mutationFn: updateQuotationTaskComment,
  });
};
